module.exports = __webpack_public_path__ + "static/media/fun15.01ffa510.png";